






import { Component, Prop, Vue } from 'vue-property-decorator';
import  MainContent  from '../components/MainContent.vue';

@Component({
    components: {
        MainContent
    },
})
export default class Jah extends Vue {
  @Prop() private softwareInfo!: string
}
